<template>
    <q-page class="flex flex-center">
        <div class="row content-center justify-center q-ma-lg">
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4">
                <div class="text-center">
                    <img alt="Black Cat Company logo" src="../assets/blackcatonly72.png"/>
                </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 text-justify q-pa-md q-ma-md">
                <h1 class="Page-Title">About Us</h1>
                <p>
                    We are the companion on your journey into automation and cloud. We strive to close the gap between
                    engineering and software teams, so they can focus on building quaility products for your business
                </p>
                <q-btn :to="{name:'services'}" color="secondary" text-color="primary" label="Discover our Services"
                       class="float-right"/>

            </div>
        </div>
    </q-page>
</template>

<script>
    export default {
        name: "Home"
    }
</script>

<style scoped>

</style>